import React from 'react';
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { changeActiveChoice } from '../../../../../../reducers/active-choice';
import { useActiveTab } from './correct-tab';
import { ApplicationRoutes } from '../../../../../constants';

const Tabs = ({ isMenuDisabled, handleNavigation }) => {
  const { activeChoice } = useSelector((state) => state.activeChoice);

  useActiveTab()

  // Company-app nav. De Studio wordt bereikt via "Lucy trainen" op het overzicht
  // en instellingen via het tandwiel in de header, dus het overzicht is de ene hub.
  const MENU_TABS = [
    { name: 'Vacatures', labelId: 'teamroom.nav.vacancies', url: ApplicationRoutes.hi5Root, shouldBeRendered: true },
  ];

  return (
    <div className="flex gap-10 items-center h-full px-5 text-2xl text-darker-sky-gray">
      {MENU_TABS.filter(tab => tab.shouldBeRendered).map(({ name, labelId, url }) => (
        <button
          key={name}
          disabled={isMenuDisabled}
          className={classNames(
            'cursor-pointer leading-none',
            { 'text-standart-ocean font-bold': name === activeChoice },
          )}
          onClick={() => handleNavigation(url, changeActiveChoice(name))}
        >
          <FormattedMessage id={labelId} />
        </button>
      ))}
    </div>
  );
};

export default Tabs;
